import { httpGet } from '../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../constants/constants';

const getChampion = () => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/users/champion`);
  return httpGet(url.href, {})
    .then((response) => {
      if (response.data.success) {
        return response.data.result;
      }
      return {};
    })
    .catch((error) => {
      throw new Error('Error getting champion', error);
    });
};

export default getChampion;
